import { Trade as trade, Trade } from "@models/trading/trade";
export class TradeSheet {
  public id;
  public portfolioId;
  public dateGenerated;
  public owner;
  public dateSubmitted;
  public dateSent;
  public dateClosed;
  public fileName;
  public status;
  public reason;

  public portfolioCount;
  public portfoliosCompleted;
  public orderCount;
  public ordersCompleted;
  public buyQuantityOrdered;
  public buyQuantityProcessed;
  public sellQuantityOrdered;
  public sellQuantityProcessed;

  public portfolioTrades: Array<any>;
  public securityOrders: Array<any>;
  public showOrders: boolean = false;

  public verifiedBy;
  public approvedBy;
  public closedBy;

  public constructor(tradeSheetDTO: any) {
    this.id = tradeSheetDTO.id;
    this.dateGenerated = tradeSheetDTO.dateGenerated;
    this.owner = tradeSheetDTO.owner || "Unknown";
    this.verifiedBy = tradeSheetDTO.verifiedBy || "Unknown";
    this.approvedBy = tradeSheetDTO.approvedBy || "Unknown";
    this.closedBy = tradeSheetDTO.closedBy || "Unknown";
    this.dateSubmitted = tradeSheetDTO.dateSubmitted;
    this.dateSent = tradeSheetDTO.dateSent;
    this.dateClosed = tradeSheetDTO.dateClosed;
    this.fileName = tradeSheetDTO.fileName;

    switch (tradeSheetDTO.status) {
      case "NEW":
        this.status = "New";
        break;
      case "SUBMITTED":
        this.status = "Submitted";
        break;
      case "SENT":
        this.status = "Sent";
        break;
      case "COMPLETED":
        this.status = "Completed";
        break;
      case "CANCELLLED":
        this.status = "Cancelled";
        break;
      case "PARTIALLY_COMPLETED":
        this.status = "Partially Completed";
        break;
      default:
        this.status = tradeSheetDTO.status;
    }
    this.reason = tradeSheetDTO.reason;

    this.portfolioCount = tradeSheetDTO.portfolioCount;
    this.portfoliosCompleted = tradeSheetDTO.portfoliosCompleted;
    this.orderCount = tradeSheetDTO.orderCount;
    this.ordersCompleted = tradeSheetDTO.ordersCompleted;
    this.buyQuantityOrdered = tradeSheetDTO.buyQuantityOrdered;
    this.buyQuantityProcessed = tradeSheetDTO.buyQuantityProcessed;
    this.sellQuantityOrdered = tradeSheetDTO.sellQuantityOrdered;
    this.sellQuantityProcessed = tradeSheetDTO.sellQuantityProcessed;

    this.securityOrders = new Array();
  }
}



// WEBPACK FOOTER //
// ./src/models/trading/tradeSheet.ts